import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllCustomerOrderDeliveryPackagesView } from "src/components/views/erp/sales/delivery/AllCustomerOrderDeliveryPackagesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/picking/allDeliveryPackages")({
	staticData: { title: i18n.t("all_packages"), legacyViewKey: "allCustomerOrderPackagesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllCustomerOrderDeliveryPackagesView />;
}
